import http from './httpService';
import config from './../config.json';

export const getAllPersons = (params, {cancelToken}) => {
	return http.get(config.api_person, {cancelToken, params});
}

export const getPersonsَArchive = (params, {cancelToken}) => {
	return http.get(`${config.api_person}/archive`, {cancelToken, params});
}

export const getPersonById = (_id) => {
	return http.get(`${config.api_person}/${_id}`);
}

export const getPersonInfoById = (_id, {cancelToken}) => {
	return http.get(`${config.api_person}/info/${_id}`, {cancelToken});
}

export const getPersonByCode = (code) => {
	return http.get(`${config.api_person}/fetch-staff/${code}`);
}

export const changeStatusPersonById = (_id) => {
	return http.get(`${config.api_person}/vip/${_id}`);
}

export const createPerson = (person) => {
	return http.post(`${config.api_person}`, person);
}

export const updatePerson = (_id, person) => {
	return http.patch(`${config.api_person}/${_id}`, person);
}

export const deletePersonById = (_id) => {
	return http.delete(`${config.api_person}/${_id}`);
}